import React from 'react';
import { twMerge } from 'tailwind-merge';
type ButtonVariant = 'primary' | 'secondary';
interface ButtonLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: ButtonVariant;
  size?: 'md' | 'nav';
}
const BASE = 'inline-flex items-center justify-center whitespace-nowrap px-6 pt-[3px] font-mark text-[12px] uppercase leading-none tracking-label transition-[background-color,color,border-color] duration-150 ease-quiet focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink';
const VARIANT: Record<ButtonVariant, string> = {
  primary: 'border border-ink bg-ink text-paper hover:border-ridge hover:bg-ridge',
  secondary: 'border border-ink text-ink hover:bg-ink hover:text-paper'
};

/** The design system's Button, rendered as a link for in-page anchors. */
export function ButtonLink({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...rest
}: ButtonLinkProps) {
  return <a className={twMerge(BASE, size === 'md' ? 'h-12' : 'h-11 px-5', VARIANT[variant], className)} {...rest} data-id="element-141" data-mp="3i1mzqnutzzvh">
      {children}
    </a>;
}